module.exports = __webpack_public_path__ + "static/assets/720ba18bcc9951d5e22a81b5d6db2d50.svg";